export default {"src":"/_next/static/media/NO_PERMISSION.2ecaece7.svg","height":61,"width":61,"blurWidth":0,"blurHeight":0};